export const DEFAULT_OPEN_FILES = ["description", "initialState"];
export const DEFAULT_CURRENT_FILE = "description";
